import { render, staticRenderFns } from "./OperaBrandWindow.vue?vue&type=template&id=5a146859&"
import script from "./OperaBrandWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBrandWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports